import { AxiosRequestConfig } from "axios";
import { get } from "../axios";

async function getFile(key: string, mode?:string) {
  try {
    const config: AxiosRequestConfig = {
      responseType: 'blob',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: { key,mode }, // assuming `key` is passed as a query param
    };

    const response = await get<any | null>('/util/linkfile', {key}, config);

  const blob = response as Blob;

    if (blob?.type==='application/json') {
        
      // It's actually JSON, not a file
      const text = await response.text();
      
      const json = JSON.parse(text);

      // Return the URL if available
      return json?.data?.url ?? null;
    } else {
      // It's a real file blob
      return response;
    }
  } catch (error) {
    console.error('Error fetching file or URL:', error);
    return null;
  }
}
export {getFile}